import { useEffect, useState } from "react";
import { GraduationCap, X } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { LiteYouTube } from "@/components/LiteYouTube";

// Video Pembelajaran: mixed video (lazy YouTube) + photo, single swipe row.
// Lightweight by design — no eager iframes — to avoid mobile-Safari OOM.
export function LearningMediaCarousel() {
  const [items, setItems] = useState([]);
  const [box, setBox] = useState(null);
  useEffect(() => { api.get("/learning-media").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div className="px-5 mt-6" data-testid="learning-media-section">
      <h3 className="font-heading font-semibold text-stone-800 flex items-center gap-2 mb-2.5">
        <GraduationCap size={24} weight="fill" className="text-emerald-500" /> Video Pembelajaran
      </h3>
      <div className="flex overflow-x-auto gap-3 pb-1 [&::-webkit-scrollbar]:hidden" style={{ scrollbarWidth: "none" }}>
        {items.map((it, i) => (
          it.type === "video" ? (
            <div key={it.id} data-testid={`lm-video-${i}`} className="shrink-0 w-72 rounded-2xl overflow-hidden border border-stone-200/60 shadow-sm bg-white">
              <div className="aspect-video bg-black"><LiteYouTube id={it.youtube_id} title={it.title} /></div>
              <p className="px-3 py-2 text-sm font-semibold text-stone-700 truncate">{it.title}</p>
            </div>
          ) : (
            <button key={it.id} data-testid={`lm-photo-${i}`} onClick={() => setBox(it.url)}
              className="shrink-0 w-72 rounded-2xl overflow-hidden border border-stone-200/60 shadow-sm bg-white text-left active:scale-[0.99] transition-transform">
              <div className="aspect-video bg-stone-100">
                <img src={it.thumb || it.url} alt={it.title} loading="lazy" className="w-full h-full object-cover"
                  onError={(e) => { e.currentTarget.style.display = "none"; }} />
              </div>
              <p className="px-3 py-2 text-sm font-semibold text-stone-700 truncate">{it.title}</p>
            </button>
          )
        ))}
      </div>
      {box && (
        <div className="fixed inset-0 z-[80] bg-black/90 flex items-center justify-center p-4" onClick={() => setBox(null)} data-testid="lm-lightbox">
          <button onClick={() => setBox(null)} className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/15 text-white flex items-center justify-center" aria-label="Tutup"><X size={22} /></button>
          <img src={box} alt="foto" className="max-w-full max-h-full object-contain rounded-xl" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
}
